import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { FAQS } from "../mock";

export default function FAQ() {
  return (
    <section className="py-20 md:py-28 bg-soft">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-center text-3xl md:text-5xl font-extrabold text-navy">
          Frequently Asked Questions (FAQs)
        </h2>
        <p className="text-center text-gray-500 mt-3 mb-12">
          Some of the most frequently-asked-questions:
        </p>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((item) => (
            <AccordionItem
              key={item.q}
              value={item.q}
              className="bg-white rounded-xl border border-gray-100 px-5 shadow-sm"
            >
              <AccordionTrigger className="text-left text-navy font-extrabold text-base md:text-lg hover:no-underline">
                Q. {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 text-base leading-relaxed pt-1 pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
